import { Component, OnInit } from '@angular/core';
import {EditToggleService} from '../services/edit-toggle.service';
import {MatSlideToggleChange} from '@angular/material';
import {BusinessManagerService} from '../user/business-manager.service';

@Component({
  selector: 'app-edit-toggle',
  templateUrl: './edit-toggle.component.html',
  styleUrls: ['./edit-toggle.component.scss']
})
export class EditToggleComponent implements OnInit {
  // toggleLabel = 'Edit Mode Off';
  checked = false;

  constructor(private _toggleService: EditToggleService) {}

  async ngOnInit() {
    this.checked = this._toggleService.getState();
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.checked = isOn;
    });
  }

  get toggleText(): string {
    return this.checked ? 'Edit Mode On' : 'Edit Mode Off';
  }

  /**
   * fn trigers when edit mode switch is clicked by user.
   */
  onEditModeChanged(event: MatSlideToggleChange) {
    this.checked = event.checked;
    this._toggleService.setState(event.checked);
    // this.toggleLabel = event.checked ? 'Edit Mode On' : 'Edit Mode Off';
  }

}
